export default import.meta.ROLLDOWN_FILE_URL_UMKQkP6PB_j6pq1U6Zl6oQ